module.exports = __webpack_public_path__ + "img/selected.df34f406.svg";